import { render, staticRenderFns } from "./StaticLock.vue?vue&type=template&id=65e7238c"
import script from "./StaticLock.vue?vue&type=script&lang=js"
export * from "./StaticLock.vue?vue&type=script&lang=js"
import style0 from "./StaticLock.vue?vue&type=style&index=0&id=65e7238c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports